import styled from 'styled-components'

export const ModalEmptyWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0px;
  left: 0px;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ModalEmptyDiv = styled.div`
  max-width: 800px;
  width: 100%;
  height: 447px;
  background: ${({ theme }) => `rgb(${theme.background.high})`};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  .btnClose {
    border: none;
    background-color: transparent;
    color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};
    font-size: 19px;
    position: absolute;
    padding: 0;
    top: 25px;
    right: 25px;
  }

  @media (max-width: 860px) {
    width: 90%;
  }

  @media (max-width: 600px) {
    .btnClose {
      right: 10px;
    }
  }
`

export const ModalEmptyContainer = styled.div`
  width: 65%;
  height: 90%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;

  flex-direction: column;

  h1 {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 700;
    font-size: 22px;
    line-height: 120%;
    /* or 26px */

    text-align: center;
    letter-spacing: -0.01em;
    margin: 0;

    /* Black */

    color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};
  }

  p {
    font-family: 'Open Sans', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 30px;
    /* identical to box height, or 188% */
    margin: 0;

    /* Dark Gray/100 */

    color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};

    text-align: center;
  }

  .ContainerImg {
    width: 208px;
    height: 186px;
  }

  @media (max-width: 860px) {
    width: 80%;

    h1 {
      font-size: 17px;
    }
    p {
      font-size: 13px;
    }
  }
`

export const ButtonBack = styled.div`
  display: flex;
  justify-content: end;
  border: none;

  button {
    border-radius: 5px;
    padding: 10px 10px 10px 10px;
    border: solid 0.1px ${({ theme }) => `rgb(${theme.component.accent})`};
    background-color: transparent;
  }
  .back-btn {
    border-radius: 5px;
    background-color: ${({ theme }) => `rgb(${theme.primary.base})`};
    color: ${({ theme }) => `rgb(${theme.background.high})`};
    border: none;
    padding: 10px 20px 10px 20px;
    font-weight: 600;
  }
`
